import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const TypePickFrom = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 24 24">
    <path d="M11 22L3 22L3 15L6 15L6 9L3 9L3 2L11 2L11 9L8 9L8 11L18 11L18 15L21 15L21 22L13 22L13 15L16 15L16 13L8 13L8 15L11 15L11 22ZM9 7L9 4L5 4L5 7L9 7ZM15 17L15 20L19 20L19 17L15 17ZM5 17L5 20L9 20L9 17L5 17Z" />
  </SvgIcon>
));

TypePickFrom.displayName = 'TypePickFrom';

export default TypePickFrom;
